import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function AboutUs() {
  const [about, setAbout] = useState(null);

useEffect(() => {
  getAbout();

  const interval = setInterval(() => {
    getAbout();
  }, 5000); // refresh every 5 sec

  return () => clearInterval(interval);
}, []);

const getAbout = () => {
  fetch(`${BASE_URL}/api/getAbout.php`, {
  cache: "no-store"
})
    .then(res => res.json())
    .then(data => setAbout(data))
    .catch(err => console.error("Error:", err));
};
  const [team, setTeam] = useState([]);

useEffect(() => {
  getTeam();

  const interval = setInterval(() => {
    getTeam();
  }, 5000);

  return () => clearInterval(interval);
}, []);

const getTeam = () => {
  fetch(`${BASE_URL}/api/getTeam.php?t=${Date.now()}`)
    .then(res => res.json())
    .then(data => setTeam(data))
    .catch(err => console.error("Error:", err));
};

  const [activePlan, setActivePlan] = useState("bachat");

  return (
    <div className="about-page">

   
       

      
<div className="about-hero">

  {/* LEFT: Static Home Page Content */}
  <div className="about-text">
      <h1>અમારા વિશે</h1>
    <h2>સંસ્થાનો પરિચય</h2>
    <p>
      શ્રી ધનલક્ષ્મી મહિલા કો-ઓપરેટિવ ક્રેડિટ સોસાયટી લિમિટેડ એ માત્ર એક નાણાકીય સંસ્થા નથી, પરંતુ મહિલાઓના આર્થિક સશક્તિકરણનું એક માધ્યમ છે. 
      અમારી સંસ્થાનો મુખ્ય ઉદ્દેશ્ય મહિલાઓમાં બચતની વૃત્તિ કેળવવી અને તેમને આર્થિક રીતે પગભર થવા માટે સરળ ધિરાણ પૂરું પાડવાનો છે. 
      સહકાર અને વિશ્વાસના પાયા પર બનેલી આ સોસાયટી વર્ષોથી મહિલાઓના ઉત્થાન માટે કાર્યરત છે.
    </p>

    <h2>મુખ્‍ય ઉદ્દેશ્યો </h2>
    <ul>
      <li>મહિલાઓને બચત અને રોકાણ માટે પ્રોત્સાહિત કરવી.</li>
      <li>જરૂરિયાતમંદ મહિલાઓને ઓછા વ્યાજદરે લોન અને ધિરાણ આપવું.</li>
      <li>મહિલા ઉદ્યોગ સાહસિકોને વ્યવસાય શરૂ કરવા માટે આર્થિક મદદ કરવી.</li>
      <li>સભાસદોના આર્થિક અને સામાજિક હિતોનું રક્ષણ કરવું.</li>
    </ul>

  </div>

  {/* RIGHT: Dynamic About Image */}
  <div className="about-image">
    <img
      src={about?.image ? `${BASE_URL}/uploads/${about.image}` : "images/2.jpeg"}
      alt="about"
    />
  </div>
</div>


{/* HISTORY & FOUNDATION */}
<div className="later-topics">
  <div>
    <h2>સંસ્થાનો ઇતિહાસ અને સ્થાપના</h2>
    <h4>"સહકારથી સમૃદ્ધિ તરફ – ૨૦૧૦ થી કાર્યરત"</h4>
    <p>
      શ્રી ધનલક્ષ્મી મહિલા કો-ઓપરેટિવ ક્રેડિટ સોસાયટી લિ. ની સ્થાપના વર્ષ ૨૦૧૩ માં કરવામાં આવી હતી. 
      છેલ્લા એક દાયકાથી પણ વધુ સમયથી અમારી સંસ્થા મહિલાઓને આર્થિક રીતે સક્ષમ અને આત્મનિર્ભર બનાવવાના મિશન સાથે કાર્ય કરી રહી છે.
    </p>
    <p>
      શરૂઆતમાં એક નાનકડા હેતુ સાથે સ્થપાયેલી આ સોસાયટી આજે હજારો મહિલા સભાસદોનો વિશ્વાસ જીતી ચૂકી છે. 
      ૨૦૧૦ થી અત્યાર સુધીની અમારી સફર પારદર્શિતા, સુરક્ષા અને મહિલા ઉત્થાનના મજબૂત પાયા પર ટકેલી છે.
    </p>
  </div>
   <div>
    <h2>અમારો અનુભવ અને સિદ્ધિઓ</h2>
    <ul>
      <li><strong>૧૫ વર્ષનો અનુભવ:</strong> ૨૦૧૦ થી સતત બેંકિંગ અને ધિરાણ ક્ષેત્રે બહેનોને શ્રેષ્ઠ સેવા પૂરી પાડી રહ્યા છીએ.</li>
      <li><strong>વિશ્વાસનું પ્રતીક</strong>: સ્થાપના કાળથી જ અમે સભાસદોની મૂડીની સુરક્ષા અને યોગ્ય વળતરને પ્રાધાન્ય આપ્યું છે.</li>
      <li><strong>મહિલા સશક્તિકરણ:</strong> છેલ્લા ૧૫ વર્ષમાં અનેક મહિલાઓને પોતાનો નાનો વ્યવસાય શરૂ કરવા માટે આર્થિક ટેકો પૂરો પાડ્યો છે.</li>
    </ul>
  </div>
</div>
 
{/* EXPERIENCE & MILESTONES, VISION & MISSION, GIFTS & APPRECIATION */}
<div className="later-topics">
  {/* EXPERIENCE & MILESTONES */}


  {/* VISION & MISSION */}
  <div>
    <h2>વિઝન અને મિશન</h2>
    <ul>
      <li><strong>મિશન:</strong> ૨૦૧૦ માં જે ઉદ્દેશ્ય સાથે શરૂઆત કરી હતી, તે મુજબ દરેક ગૃહિણી અને કામકાજી મહિલાને કરકસર અને બચત દ્વારા આર્થિક રીતે મજબૂત બનાવવી.</li>
      <li><strong>વિઝન:</strong> ટેકનોલોજી અને સહકારના સમન્વયથી આગામી વર્ષોમાં રાજ્યની અગ્રણી મહિલા ક્રેડિટ સોસાયટી બનવું.</li>
    </ul>
  </div>

  {/* GIFTS & APPRECIATION */}
  <div>
    <h2>સભાસદોને પ્રોત્સાહક ભેટ</h2>
    <ul>
      <li>દિવાળી કે વાર્ષિક ભેટ: દર વર્ષે વાર્ષિક સભા દરમિયાન અથવા તહેવારોના સમયે સભાસદોને ઉપયોગી વસ્તુઓ ભેટ (Gifts) તરીકે આપવામાં આવે છે.</li>
      <li>શૈક્ષણિક પુરસ્કાર: સભાસદોના તેજસ્વી સંતાનોને શૈક્ષણિક પ્રોત્સાહન ઇનામો આપવામાં આવે છે.</li>
    </ul>
  </div>
</div>
 
    
      {/* SERVICES */}
        {/* SERVICES */}
      <div className="modern-section">
        <h2>અમારી સેવાઓ</h2>

        <div className="modern-container">
<div 
  className={`modern-card ${activePlan === "bachat" ? "active" : ""}`}
  onClick={() => setActivePlan("bachat")}
>
             <div className="icon">
    <i className="bi bi-piggy-bank"></i>
  </div>
            <h4>બચત યોજના</h4>
            <p>નિયમિત બચત કરીને ભવિષ્ય સુરક્ષિત બનાવો.</p>
          </div>

        <div 
  className={`modern-card ${activePlan === "loan" ? "active" : ""}`}
  onClick={() => setActivePlan("loan")}
>
            <div className="icon">
    <i className="bi bi-shield-check"></i>
  </div>
            <h4>લોન સુવિધા</h4>
            <p>સરળ પ્રક્રિયા સાથે ઝડપી લોન મેળવો.</p>
          </div>

          <div 
  className={`modern-card ${activePlan === "insurance" ? "active" : ""}`}
  onClick={() => setActivePlan("insurance")}
>
           <div className="icon">
    <i className="bi bi-shield-check"></i>
  </div>
            <h4>વીમા યોજના</h4>
            <p>તમારા પરિવાર માટે સુરક્ષિત વીમા લાભ.</p>
          </div>

          <div 
  className={`modern-card ${activePlan === "fd" ? "active" : ""}`}
  onClick={() => setActivePlan("fd")}
>
            <div className="icon">
    <i className="bi bi-graph-up-arrow"></i>
  </div>
            <h4>ફિક્સ ડિપોઝિટ</h4>
            <p>આકર્ષક વ્યાજ સાથે સુરક્ષિત રોકાણ.</p>
          </div>

        </div>
      </div>

      {/* DETAIL SECTION */}
      {activePlan && (
        <div className="plan-detail">

          {activePlan === "bachat" && (
            <>
             

  <div className="plan-grid">

    {/* BOX 1 */}
    <div className="plan-box">
      <h2>બચત યોજના વિગત</h2>
      <p>₹100/- કે ₹100/- ના ગુણાંક માં ગમે તેટલી રકમ માટે 1 વર્ષ ની મુદત માટે ખાતું ખોલાવી શકાય છે.</p>
      <ul>
        <li>₹500 /- ના 12 માસ મુજબ ₹6300/- (સ્ટીલ વાડકી નંગ - 2 )</li>
        <li>₹1000/- ના 12 માસ મુજબ ₹12600/- (સ્ટીલ ગ્લાસ  નંગ - 3 )</li>
        <li>₹2000/- ના માસ મુજબ ₹25200/- (સ્ટીલ ગ્લાસ  નંગ - 6 )</li>
        <li>₹5000/- ના માસ મુજબ ₹63000/- (સ્ટીલ તપેલું  નંગ - 1 )</li>
      </ul>
    </div>

    {/* BOX 2 */}
    <div className="plan-box">
      <h2>અન્ય બચત યોજનાઓ</h2>
      <p>બચત દ્વારા ભવિષ્ય સુરક્ષિત બનાવો.</p>
      <ul>
        <li>સામાન્ય બચત 3.5% વ્યાજ નો દર</li>
        <li>ફરજીયાત બચત 3.5% વ્યાજ નો દર</li>
      </ul>
    </div>

  </div>


              
            </>
          )}

          {activePlan === "loan" && (
            <>
             <h2>પ્રથમ લોન 50000/- મળશે </h2> 
                <ul>
                  <li>લોન લેતી વખતે જે 20% બચત મુકાવતા હતા તેમાં ફેરફાર કરી ને હવે પછી થી 10% બચત જમા કરાવવી એવું નક્કી કરેલ છે.</li>
                  <li>ભાડુઆત સભાપદો માટે ત્રણેય જમીન મિલકત આપીને ક્રમશ: 50,000/- થી 75,000/- (રેગ્યુલર હપ્તા હોય તો ) સુધી મળશે.</li>
                  <li>ટૂંક સમય માટે 55 વર્ષ સુધી ના સભાપદ વીમા સાથે લેવાનું ચાલુ કરેલ છે.</li>
                </ul>
             <div className="plan-grid"> 
             
  <div className="plan-box">
              
         <h2>સોસાયટી ના શેર સભાપદ બની નીચે મુજબ ના લાભ મેળવો </h2>
              <ul>
                <li>સાધન ધિરાણ  : 2,00,000/- (બે લાખ) સુધી </li>
                <li>પ્રોપર્ટી ધિરાણ  : 5,00,000/- (પાંચ લાખ) સુધી </li>
<li>રોકડ ધિરાણ  : 2,00,000/- (બે લાખ) સુધી </li>
<li>એચ. પી. ધિરાણ  : 5,00,000/- (પાંચ લાખ) સુધી </li>
                <li>અનાજ ધિરાણ  : 25,000/- (પચ્ચીસ  હજાર) સુધી </li>
                <li>એફ. ડી. સામે : 90%</li>
              </ul>
    </div>

    {/* BOX 2 */}
    <div className="plan-box">
      <h4>4 ના ગ્રુપ માં સભાપદ બની તુરંત જ ₹50,000/- રોકડ ધિરાણ મેળવો. </h4>
    
    </div>
    </div>

     <h4>લોન નિયમિત ભરનાર ને નિયમો અનુસાર વ્યાજ રિબેટ આપવામાં આવશે. </h4>
           
            
            </>
          )}

          {activePlan === "insurance" && (
            <>
              <h2>વીમા યોજના વિગત</h2>
              <h5>તા. 01/04/2025 થી રૂ 3,00,000/- ની વીમા યોજના સંપૂર્ણ પણે ચાલુ થઇ ગયેલ છે..</h5>
              <h5>વીમો કરાવનાર સભાપદ ને ફ્રી ગિફ્ટ નો લાભ મળશે.</h5>
              <ul>
                <li> તા. : 01/04/2025 થી ધનલક્ષ્મી વીમા સુરક્ષા કવચ યોજના રૂ 3,00,000/- (ત્રણ લાખ )નો સંપૂર્ણં પણે અમલ શરુ થાય ગયેલ છે.</li>
                <li>અગાઉ ની તા : 01/04/2022 થી "શ્રી ધન લક્ષ્મી વીમા સુરક્ષા કવચ" વીમા યોજના રૂ 2,00,000/- (બે લાખ ) વીમાયોજના માં જોડાય શકશે, તેમજ જ્યાં સુધી સભાપદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો મળવા પાત્ર છે.</li>
                <li>18 થી 55 વર્ષ સુધી ના સભાપદ વીમા યોજના માં જોડાય શકશે, તેમજ જ્યાં સુધી સભાપદ તરીકે ચાલુ રહેશે ત્યાં સુંભી વીમો મળવા પાત્ર છે.</li>
              </ul>
            </>
          )}

          {activePlan === "fd" && (
            <>
        <div className="plan-grid">    
  <div className="plan-box">
              
        <h2> ફિક્સ ડિપોઝિટ યોજના </h2>
              <ul>
                <li>1 વર્ષ માટે 7%</li>
                <li>2 વર્ષ માટે 8%</li>
                <li>3 વર્ષ માટે 9%</li>
                 <li>9 વર્ષે  બમણા</li>
              </ul>
    </div>
     <div className="plan-box">
         
        <h2>  :: 9 વર્ષે બમણા :: </h2>
              <ul>
                <li>₹5,000 ની F.D. ઉપર સ્ટીલ બાઉલ નંગ -1</li>
                <li>₹10,000 ની F.D. ઉપર સ્ટીલ ડબ્બો નંગ -1</li>
                <li>₹25,000 ની F.D. ઉપર સ્ટીલ કડાઈ નંગ -1</li>
                <li>₹50,000 ની F.D. ઉપર સ્ટીલ તપેલું નંગ -1    </li>
              </ul>
    </div>


    {/* BOX 2 */}
    <div className="plan-box">
      <h5>₹ 25000 /- કે તેથી વધુ રકમ ની ફિક્સ ડિપોઝિટ ત્રણ વર્ષ માટે મુકનાર ને ફ્રી ગિફ્ટ નો લાભ મળશે </h5>
     
    </div>
    </div>
           
            </>
          )}

        </div>
      )}
<div className="modern-section">
        <h2>અમને કેમ પસંદ કરશો?</h2>

        <div className="modern-container">
<div className="modern-card">
             <div className="icon">
   <i className="bi bi-check-circle"></i>
  </div>
           <h4>પારદર્શક વહીવટ</h4>
      <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

        <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
   
  </div>
           <h4>મહિલા સંચાલિત</h4>
      <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

        <div className="modern-card">
           <div className="icon">
      <i className="bi bi-lightning"></i>
  </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
      <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

         <div className="modern-card">
            <div className="icon">
     <i className="bi bi-shield-lock"></i>
  </div>
            <h4>સરળ પ્રક્રિયા</h4>
      <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>

        </div>
      </div>
      {/* TEAM */}
    <div className="team-section">
  <h2>અમારી ટીમ</h2>

  <div className="team-container">

    {team.length > 0 ? (
      team.map((member, index) => (
        <div className="team-card" key={index}>

  <div className="team-image">
    <img
      src={`${BASE_URL}/uploads/${member.photo}`}
      alt=""
    />
  </div>
<div className="team-text">
  <h3>{member.name}</h3>
  <p>{member.role}</p>
</div>
</div>
      ))
    ) : (
      <p>No team members found</p>
    )}

  </div>
</div>

    </div>
  );
}